import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ComboBoxModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ComboBoxModule,
    FormsModule
  ],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent {
  jobName: string = '';
  email: string = '';
  deleteJobName: string = '';

  taskOptions: string[] = ['Task A', 'Task B', 'Task C', 'Task D'];
  selectedTask: string | null = null;

  frequencyOptions = [
    { value: "* * * * *", label: "Every Minute" },
    { value: "0 * * * *", label: "Hourly" },
    { value: "0 0 * * *", label: "Daily" },
    { value: "0 0 * * 0", label: "Weekly (Every Sunday)" },
    { value: "0 0 1 * *", label: "Monthly (1st of the Month)" }
  ];
  selectedFrequency: string | null = null;

  private apiUrl = 'http://localhost:7233/api/jobs';

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) { }

  closeModal(): void {
    this.dialogRef.close();
  }

  createJob() {
    if (!this.jobName || !this.selectedTask || !this.selectedFrequency) {
      alert('Please fill all fields');
      return;
    }

    const jobData = {
      jobName: this.jobName,
      task: this.selectedTask,
      frequency: this.selectedFrequency,
      email: this.email || null
    };

    this.http.post(`${this.apiUrl}/add`, jobData).subscribe({
      next: (response) => {
        alert('Job created successfully!');
        this.dialogRef.close();
      },
      error: (error) => {
        console.error('Error creating job:', error);
        alert('Failed to create job');
      }
    });
  }

  deleteJob() {
    if (!this.deleteJobName) {
      alert('Enter job name to delete');
      return;
    }

    const deleteData = { jobName: this.deleteJobName };

    this.http.post(`${this.apiUrl}/delete`, deleteData).subscribe({
      next: () => {
        alert('Job deleted successfully!');
        this.dialogRef.close();
      },
      error: (error) => {
        console.error('Error deleting job:', error);
        alert('Failed to delete job');
      }
    });
  }
}
